import AdminRoutes from './routes/AdminRoutes';

function App() {
  return <AdminRoutes />;
}

export default App;
